<template>
  <message-push-native
    v-if="start"
    :URL="url"
    :token="token"
    :username="username"
    :componentSet="componentSet"
    @message-get="onMessageGet"
  >
  </message-push-native>
</template>

<script>
import messagePushNative from './message-push-native'
import API from '../../api/api'
export default {
  props: {
    componentSet: {
      type: Array,
      required: true
    }
  },
  components: {
    messagePushNative
  },
  data () {
    return {
      start: false,
      url: '',
      token: '',
      username: ''
    }
  },
  methods: {
    getWsInfo () {
      API.common.getWsInfo().then(res => {
        this.username = this.$store.state.userName
        let protocol = location.protocol === 'http:' ? 'ws://' : 'wss://'
        this.url = `${protocol}${location.hostname}${location.port ? ':' : ''}${location.port}/mps/mps`
        this.token = res.data
        this.start = true
      })
    },
    onMessageGet (data) {
      this.$emit('message-get', data)
    }
  },
  mounted () {
    this.getWsInfo()
    this.$emit('init')
  },
  watch: {
    destination () {
      if (this.url && this.destination) {
        this.start = true
      }
    }
  }
}
</script>
